import { useCallback, useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api, fmtAZN } from "@/lib/api";
import { TxAdmin } from "@/components/admin/TxAdmin";
import { UsersAdmin } from "@/components/admin/UsersAdmin";
import { SupportAdmin } from "@/components/admin/SupportAdmin";
import { PromoAdmin } from "@/components/admin/PromoAdmin";
import { SettingsAdmin } from "@/components/admin/SettingsAdmin";

const tabCls = "rounded-full px-4 sm:px-5 py-2.5 data-[state=active]:bg-[#D4AF37] data-[state=active]:text-black text-zinc-400 font-semibold";
const TABS = [["tx", "Əməliyyatlar", TxAdmin], ["users", "İstifadəçilər", UsersAdmin], ["support", "Dəstək", SupportAdmin], ["promo", "Promokodlar", PromoAdmin], ["settings", "Parametrlər", SettingsAdmin]];

export default function AdminPanel() {
  const [stats, setStats] = useState(null);
  const load = useCallback(() => api.get("/admin/stats").then(({ data }) => setStats(data)), []);
  useEffect(() => { load(); }, [load]);

  const cards = stats ? [["İstifadəçilər", stats.users], ["Gözləyən sorğular", stats.pending], ["Cəmi depozit", fmtAZN(stats.total_deposits)], ["Cəmi çıxarış", fmtAZN(stats.total_withdrawals)]] : [];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12" data-testid="admin-page">
      <h1 className="font-display font-black text-4xl tracking-tighter mb-8">Admin panel</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        {cards.map(([l, v], i) => (
          <div key={l} className="rounded-2xl border border-white/10 bg-[#111] p-5" data-testid={`admin-stat-${i}`}>
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500">{l}</p>
            <p className="font-display font-bold text-2xl mt-2 gold-text">{v}</p>
          </div>
        ))}
      </div>
      <Tabs defaultValue="tx">
        <TabsList className="bg-[#111] border border-white/10 rounded-full p-1 h-auto mb-8 flex-wrap justify-start">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} className={tabCls} data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([v, , C]) => <TabsContent key={v} value={v}><C onChange={load} /></TabsContent>)}
      </Tabs>
    </div>
  );
}
